import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleAnalyticsLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M24.6034 24.4441C24.6084 25.4396 24.2035 26.3895 23.4914 27.0526C22.7792 27.7156 21.8285 28.0281 20.8804 27.9107C19.1745 27.6475 17.9243 26.0994 17.9659 24.3016V3.63263C17.9247 1.83289 19.1779 0.284086 20.8861 0.023563C21.8332 -0.0920329 22.7824 0.221294 23.4932 0.884159C24.204 1.54702 24.6082 2.49582 24.6034 3.49016V24.4441Z",
		fill: "#F9AB00"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.7172 21.0205C5.5501 21.0205 7.03596 22.5699 7.03596 24.4812C7.03596 26.3924 5.5501 27.9418 3.7172 27.9418C1.8843 27.9418 0.398438 26.3924 0.398438 24.4812C0.398438 22.5699 1.8843 21.0205 3.7172 21.0205ZM12.4496 10.5317C10.608 10.6369 9.17917 12.2477 9.2219 14.1704V23.4661C9.2219 25.9889 10.2864 27.5204 11.8462 27.8469C12.8254 28.0538 13.8419 27.7905 14.6145 27.1299C15.3871 26.4693 15.8338 25.4814 15.831 24.4396V14.0101C15.8326 13.0788 15.4754 12.1858 14.8396 11.5317C14.2037 10.8777 13.3426 10.5173 12.4496 10.5317Z",
		fill: "#E37400"
	})]
});
export default SvgGoogleAnalyticsLogo;
